<app-header [title]="project()?.name || 'Project'"
            [description]="project()?.topic || 'Manage your project settings'">
  @if (canWriteProject()) {
    <button suffix
            mat-raised-button
            type="button"
            (click)="toggleEdit()">
      <mat-icon>{{ showForm() ? 'close' : 'edit' }}</mat-icon>
      <span>{{ showForm() ? 'Edit' : 'Edit' }}</span>
    </button>
  }
</app-header>

<section>
  @if (project(); as project) {
    @if (showForm()) {
      <div class="project-detail">
        <form [formGroup]="form">
          <mat-form-field class="full-width">
            <mat-label>Project Name</mat-label>
            <input matInput formControlName="name"/>
          </mat-form-field>
          <mat-form-field class="full-width">
            <mat-label>Topic</mat-label>
            <textarea matInput formControlName="topic"></textarea>
          </mat-form-field>

          @if (canWriteProject()) {
            <div class="actions">
              <app-save-btn
                [disabled]="form.invalid"
                [element]="project"
                (clicked)="save()"
                (savingDone)="stopEdit()"
              ></app-save-btn>
              @if (!project.exploringMode) {
                <button mat-raised-button
                        matTooltip="Other users can view your project, but cannot make changes"
                        type="button"
                        (click)="changeExplore(true)">
                  <mat-icon>publish</mat-icon>
                  <span>Permit exploring</span>
                </button>
              } @else {
                <button mat-raised-button
                        matTooltip="Other users can not view your project anymore"
                        type="button"
                        (click)="changeExplore(false)">
                  <mat-icon>unpublished</mat-icon>
                  <span>Stop exploring</span>
                </button>
              }
            </div>
          }
        </form>
      </div>
    }

    @if (project.id) {
      <div class="keywords-detail">
        <app-keyword-list [projectId]="project.id"
                          [editable]="canWriteProject()"></app-keyword-list>
      </div>
      <div class="keywords-detail">
        <app-screening-criterias-list [projectId]="project.id"
                                      [editable]="canWriteProject()"></app-screening-criterias-list>
      </div>
    }
    <div class="keywords-detail actions">
      <button class="next-btn"
              mat-raised-button
              (click)="navigateToNextStep()">
        Next
      </button>
    </div>
  }
</section>
